// extracted by mini-css-extract-plugin
export default {"tabs_outer":"MG61_q_Fqjz_RS90qy32","tabsOuter":"MG61_q_Fqjz_RS90qy32","tabs":"XbWOSg8DxyRj2i9HbE_Q","tab":"dc3C5Xy9mvuNdLFVrAMA","on":"YYk2o5nCAoi1M7PD0bsA"};